import Skeleton from 'components/3catinfo/Skeleton';
import clsx from 'clsx';
import styles from './destacatInformatiu.module.scss';

const DestacatInformatiuSkeleton = (props) => {
    const { style } = props;

    const stylePoster = clsx({
        [styles.hasHover]: true,
        [styles.poster_destacat_informatiu]: true
    });

    return (
        <div style={{ ...style }} className={`${stylePoster}`}>
            <div className={styles.wrapperSkeleton}>
                <Skeleton imatge className={styles.imatge} />
            </div>
        </div>
    );
};

export default DestacatInformatiuSkeleton;
